// extracted by mini-css-extract-plugin
export default {"centered":"EhR3M","unsubscribe-width":"_3XlSj","unsubscribeWidth":"_3XlSj"};